import React, { FunctionComponent } from 'react'

import { useField } from 'formik'
import { SpaceProps, WidthProps } from 'styled-system'

import { Dropzone } from '@/atoms/dropzone'
import { DropzoneFile } from '@/atoms/dropzone/dropzone'
import { isEmpty } from '@/helpers/type-guards'
import { FileExtension } from '@/models/common'

import FieldWrapper from './field-wrapper'

export interface DropzoneProps {
  label?: string
  fieldProps?: SpaceProps & WidthProps
  name?: string
  acceptedTypes?: Array<FileExtension>
  maxSize?: number
  multiple?: boolean
  hideErrorMessage?: boolean
  downloadUploadedFile?: () => void
  tooltip?: string
}

const DropzoneField: FunctionComponent<DropzoneProps> = ({
  label,
  fieldProps,
  name,
  acceptedTypes,
  maxSize,
  multiple = false,
  hideErrorMessage,
  downloadUploadedFile,
  tooltip,
}: DropzoneProps) => {
  const [field, meta, helpers] = useField(name)

  const handleUploadFile = (files: DropzoneFile[]): void => {
    helpers.setValue(multiple ? files : files[0])
  }

  const handleRemoveFile = (files: DropzoneFile[]): void => {
    helpers.setValue(multiple ? files : '')
  }

  return (
    <FieldWrapper id={field.name} meta={meta} label={label} fieldProps={fieldProps} hideErrorMessage={hideErrorMessage} tooltip={tooltip}>
      <Dropzone
        acceptedTypes={acceptedTypes}
        initialFile={!isEmpty(field.value) ? { uploadedFile: field.value, downloadUploadedFile } : null}
        maxSize={maxSize}
        onFileUpload={handleUploadFile}
        onFileRemove={handleRemoveFile}
        multiple={multiple}
      />
    </FieldWrapper>
  )
}

DropzoneField.displayName = 'DropzoneField'

export default DropzoneField
